const INVALID_QRCODE = 'The PAssion CARES QR is currently invalid.<br> <br> The QR Code for event  <br> EVENTNAME <br> Is valid between <br> STARTDATE to ENDDATE.<br><br>Please contact the organiser for more information.';
const EXCLUSIVE_MEMBER_ONLY = '<div>PAssion CARES is exclusive to PAssion Members only.<br /><br />' +
    'We noted that you are not a PAssion Member yet.' +
    '<br /><br />Sign up for a FREE PAssion e-Membership* ' +
    '<a href="https://go.gov.sg/passioncaresemembership" target="_blank">here</a> to participate.' +
    '</div>' +
    '<br /><div style="font-size:12px; text-align:center" className="p-2">*PAssion e-Membership is applicable to 15 years old and above Singpass holders.' +
    '</div>'
const EXCLUSIVE_MEMBER_ONLY_EXTRA = '<div style="font-size: 0.6em !important">PAssion CARES is exclusive to PAssion Members only.<br /><br />We noted that you are not a PAssion Member yet.<br /><br />' +
    'To participate, please sign up for your PAssion Card ' +
    '<a href="https://www.onepa.gov.sg/PA-membership" target="_blank">here</a> or ' +
    'sign up for a free* PAssion POSB debit card <a href="http://posb.com.sg/passion" target="_blank">here</a>.' +
    '<br /><br />*Please note that you will be eligible to participate in PAssion ' +
    'CARES after 5 working days upon your membership application.' +
    '<br /><br />Terms and conditions apply.</div>'

const ONEPALINK = "https://www.onepa.gov.sg/passion-card/what-is-passion-cares"
const YUULINK = "https://www.onepa.gov.sg/passion-card/passion-partners/yuu-singapore"

const UNABLE_TO_PROCESS = "We are unable to process your request at the moment.<br>Please try again in 5 minutes.</br> Thank you for your patience.";

const TRY_AGAIN_IN_15_MINUTES = "We are unable to process your request at the moment.<br>Please try again in 15 minutes.</br> Thank you for your patience.";

const SESSION_EXPIRED = 'The PAssion CARES QR Code session has expired. <br>Please scan the PAssion CARES QR again. <br>If the issue persists, please contact the organiser for assistance.';

const SUPPLEMENTARY_USER = `Supplementary Members are not eligible to participate in the PAssion CARES programme as a valid PAssion Membership/e-Membership is required for the crediting of the points. Thank you.<br/>
If you are above 15 years old, sign up for a FREE PAssion e-Membership <a href="https://go.gov.sg/passioncaresemembership" target="_blank">here</a> to participate.
`

const NON_ACTIVE_MEMBER = `Your PAssion Card is still being processed. Please try again after you have received your card.<br>Alternatively, please contact PA Contact Centre @ 62255322 for further assistance.`

export {
    INVALID_QRCODE,
    EXCLUSIVE_MEMBER_ONLY,
    ONEPALINK,
    YUULINK,
    UNABLE_TO_PROCESS,
    SESSION_EXPIRED,
    SUPPLEMENTARY_USER,
    NON_ACTIVE_MEMBER,
    TRY_AGAIN_IN_15_MINUTES
}
